function initBannerImageSlider() {
  let swiperBanner = document.querySelectorAll('swiper-container.image-slider');
  swiperBanner = Array.from(swiperBanner).find((element) => {
    return element.offsetParent !== null;
  });

  if (!swiperBanner) {
    return;
  }

  const swiper = swiperBanner.swiper;
  if (!swiper) {
    return;
  }

  if (!swiperBanner.shadowRoot) {
    return;
  }

  const pagination = swiperBanner.shadowRoot.querySelector('.swiper-pagination');
  if (!pagination) {
    return;
  }

  const sheet = new CSSStyleSheet();
  sheet.replaceSync(`
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      background-color: #fff;
      border-radius: 50%;
      box-sizing: content-box;
    }
    .swiper-pagination-bullet.swiper-pagination-bullet-active{
      background-color: #044d79;
      color: #044d79;
      border: 3px solid #fff;
    }
  `);

  const currentSheets = swiperBanner.shadowRoot.adoptedStyleSheets || [];
  swiperBanner.shadowRoot.adoptedStyleSheets = [...currentSheets, sheet];

  const prevBtn = document.querySelector('#prev-image-slide-btn');
  const nextBtn = document.querySelector('#next-image-slide-btn');
  if (!prevBtn || !nextBtn) {
    return;
  }
  prevBtn.style.display = 'flex';
  prevBtn.style.justifyContent = 'center';
  prevBtn.style.alignItems = 'center';
  prevBtn.style.cursor = 'pointer';
  nextBtn.style.display = 'flex';
  nextBtn.style.justifyContent = 'center';
  nextBtn.style.alignItems = 'center';
  nextBtn.style.cursor = 'pointer';
  
  prevBtn.addEventListener('click', () => swiper.slidePrev());
  nextBtn.addEventListener('click', () => swiper.slideNext());

  pagination.prepend(prevBtn);
  pagination.appendChild(nextBtn);
  pagination.classList.add('flex', 'justify-center', 'items-center', 'gap-2');
  pagination.style.display = 'flex';
  pagination.style.justifyContent = 'center';
  pagination.style.alignItems = 'center';
  pagination.style.gap = '0.5rem';
  pagination.style.marginBottom = '1rem';
}

document.addEventListener('DOMContentLoaded', () => {
  initBannerImageSlider();
});
